var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRewindNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FDB717",
    width: 14,
    height: 14,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1518 3.9593a.49908.49908 0 01.11487.31853v5.06988c0 .27563-.22345.49908-.49909.49908a.49908.49908 0 01-.31852-.11486L6.87796 7.6002l.00082 1.7475c0 .27563-.22344.49908-.49908.49908a.49908.49908 0 01-.31852-.11486l-3.0578-2.53494c-.2122-.17592-.2416-.49055-.06569-.70274a.49908.49908 0 01.0657-.0657L6.06118 3.8936c.2122-.17592.52683-.1465.70274.0657a.49908.49908 0 01.11486.31852l-.00082 1.74638 2.5711-2.1306c.2122-.17592.52683-.1465.70275.0657z",
    fill: "#000"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/e3056e037/media/rewind-notification.svg";
export { SvgRewindNotification as ReactComponent };